var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { connect } from 'react-redux';
import Slider from 'rc-slider';
import Grid from 'material-ui/Grid/Grid';
import { scenarioSpeedChange } from './actions';
export var SPEED_MULTIPLIERS = [0.15, 0.25, 0.5, 0.75, 1, 1.5, 2, 4, 6, 10];
var RawOffsetMultiplier = /** @class */ (function (_super) {
    __extends(RawOffsetMultiplier, _super);
    function RawOffsetMultiplier(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.changeIndex = function (value) {
            var mappedScenarioSpeed = SPEED_MULTIPLIERS[value];
            _this.props.scenarioSpeedChange(mappedScenarioSpeed);
        };
        return _this;
    }
    RawOffsetMultiplier.prototype.render = function () {
        var scenarioSpeed = this.props.scenarioSpeed;
        var scenarioSpeedIndex = SPEED_MULTIPLIERS.findIndex(function (multiplier) { return multiplier === scenarioSpeed; });
        return (React.createElement(React.Fragment, null,
            React.createElement(Grid, { item: true, xs: 12, md: 3 },
                React.createElement("span", null, "Playback speed")),
            React.createElement(Grid, { item: true, xs: 12, md: 6 },
                React.createElement(Slider, { min: 0, max: SPEED_MULTIPLIERS.length - 1, value: scenarioSpeedIndex, onChange: this.changeIndex })),
            React.createElement(Grid, { item: true, xs: 12, md: 3 },
                React.createElement("span", null, scenarioSpeed))));
    };
    return RawOffsetMultiplier;
}(React.PureComponent));
export var OffsetMultiplier = connect(function (_a) {
    var scenarioSpeed = _a.scenarioSpeed;
    return ({ scenarioSpeed: scenarioSpeed });
}, { scenarioSpeedChange: scenarioSpeedChange })(RawOffsetMultiplier);



//////////////////
// WEBPACK FOOTER
// ./src/components/VehicleController/OffsetMultiplier.tsx
// module id = 1816
// module chunks = 0